<template>
  <div class="app" v-if=" appMode === 'service'">
    <div class="app-body">
      <main class="main">
      <div class="p-0 container-fluid">
        <router-view></router-view>
      </div>
      </main>
    </div>
  </div>
  <div class="app" v-else>
    <AppHeader :navItems="nav" @showNavBar="toggleVisible"/>
    <ResponsiveNav :visible="visible" :navItems="nav" @hideMenu="hideMenu"/>
    <PageTitle :title="name" :fabList="this.fab"/>
    <!-- <Sessionlogout /> -->
    <div class="app-body">
      <main class="main">
      <div class="container-fluid">
        <router-view></router-view>
      </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import fab from '../_fab'
import { Header as AppHeader, Footer as AppFooter, PageTitle, ResponsiveNav } from '../components/'
import { mapGetters } from 'vuex'
import Sessionlogout from '../components/Sessionlogout'

export default {
  name: 'full',
  components: {
    AppHeader,
    AppFooter,
    PageTitle,
    ResponsiveNav,
    Sessionlogout
  },
  data () {
    return {
      nav: nav.items,
      fab: fab,
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hideMenu () {
      this.visible = false
    }
  },
  computed: {
    ...mapGetters(['appMode']),
    name () {
      if (this.$route.path.includes('/process/modify/')) {
        return 'Triaging'
      } else {
        return this.$route.name
      }
    },
    isSessionTimeout () {
      return process.env.SESSION_TIMEOUT
    }
  },
  beforeCreate () {
    this.$store.dispatch('setMetaData')
  }
}
</script>
<style>
.b-form-group.required .col-form-label:after {
  content:"*";
  color:red;
}

.table.b-table>thead>tr>th {
  background-color: white;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}

.main .container-fluid  {
  padding: 0 20px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue